"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.datepickerContextDefaultValue = void 0;
var _react = _interopRequireDefault(require("react"));
const datepickerContextDefaultValue = exports.datepickerContextDefaultValue = {
  focusedDate: null,
  isDateFocused: () => false,
  isDateSelected: () => false,
  isDateHovered: () => false,
  isDateBlocked: () => false,
  isFirstOrLastSelectedDate: () => false,
  onDateFocus: () => {},
  onDateHover: () => {},
  onDateSelect: () => {},
  start: new Date(),
  end: new Date(),
  incomingStartDate: new Date(),
  incomingEndDate: new Date()
};
var _default = exports.default = /*#__PURE__*/_react.default.createContext(datepickerContextDefaultValue);